import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

export const FiltersWrapper = styled.div`
  margin-top: ${layout.measurements.spacingSmall};

  ${media.smallOnly`
    margin: 0;
  `};
`;
